import { ref, computed } from 'vue'
import { zh, en } from './content.mjs'

export { CONTACT_EMAIL, TWITTER_URL, SITE_URL, WECHAT_ID, TELEGRAM_HANDLE, TELEGRAM_URL } from './content.mjs'

// 语言由网址决定：/ 开头是中文，/en/ 开头是英文（搜索引擎能分别收录两种语言）
export const lang = ref('zh')
export const content = computed(() => (lang.value === 'en' ? en : zh))

export const isEnPath = path => path === '/en' || path.startsWith('/en/')

export function setLangFromPath(path) {
  lang.value = isEnPath(path) ? 'en' : 'zh'
  document.documentElement.lang = lang.value === 'zh' ? 'zh-CN' : 'en'
}

// 把中文路径转成当前（或指定）语言的路径：'/services/x/' -> '/en/services/x/'
export function localePath(path, l = lang.value) {
  const base = stripLang(path)
  return l === 'en' ? (base === '/' ? '/en/' : '/en' + base) : base
}

export function stripLang(path) {
  if (!isEnPath(path)) return path || '/'
  const rest = path.slice(3)
  return rest === '' ? '/' : rest
}

// 访客手动选过的语言
export function readLangPref() {
  try {
    const v = localStorage.getItem('musesec-lang')
    return v === 'zh' || v === 'en' ? v : null
  } catch (e) { return null }
}
export function saveLangPref(l) {
  try { localStorage.setItem('musesec-lang', l) } catch (e) { /* 隐私模式等 */ }
}

// 浏览器语言是否中文；搜索引擎爬虫一律不跳转，避免中文页被当成英文收录
export function browserPrefersZh() {
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || 'zh']).map(s => String(s).toLowerCase())
  return langs.some(l => l.startsWith('zh'))
}
export const isBot = () => /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|twitterbot|linkedinbot|telegrambot|whatsapp|lighthouse|headless/i.test(navigator.userAgent || '')
